// Solid icons
import {
    faCalendar,
    faPencil,
    faTrash,
    faXmark,
    faEllipsisV,
} from "@fortawesome/free-solid-svg-icons";

// Import sub-components
import { Followups } from "../../detailPage/leads/Followups";
import { Notes } from "../../detailPage/leads/Notes";
import { Meetings } from "../../detailPage/leads/Meetings";
import { Documents } from "../../detailPage/leads/Documents";
import { Col, Dropdown, Nav, Tab } from 'react-bootstrap';
import useLocalStorageState from "use-local-storage-state";
import { useRef, useState } from "react";
import { toast } from "sonner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { UpdateDeal } from "../UpdateDeal";
import DeleteModal from "../../DeleteModal";
import { DeleteRequest } from "../../../Utils/hooks/ApiHandler";
import { useOutsideClickHandler } from "../../../Utils/hooks/useOutsideClickHandler";
import { fetchTemporaryFilterData, navigateBackFromCrmDetail } from "../../../Utils/helpers/commonhelper";
import { useGetEssentials } from "../../../Utils/hooks/useGetEssentials";
import { useGlobalState } from "../../../Utils/hooks/useFilterQueryValue";
import { useLocation } from "react-router-dom";


export const DealActivityPanel = ({
    // headers,
    // extras,
    // onClose,
    // dealGrant,
    individualDealData,
    dealId,
    canEdit,
    setCallLogOpen,
    refetchDealDetails,
    refetchDeals,
    // setSelectedStageId,
    // just to ensure if actions dropdown is necessarily be shown or not
    isActionDropReqd
}) => {

    const { headers, extras, navigate, loginUserId } = useGetEssentials()
    const location = useLocation()

    const [PERMISSION, _] = useLocalStorageState('permission')
    const dealGrant = PERMISSION.deals

    const dealsMetadata = localStorage.getItem("dealsMetadata");
    const currAdvFilter = dealsMetadata?.currAdvFilter;

    const [dealFilterDataParms] = useGlobalState('dealsFilterParams')

    const handleCloseDealDetails = () => {
        navigateBackFromCrmDetail(navigate, location, '/deals', {
            beforeNavigate: () => {
                if (currAdvFilter === "apply") {
                    fetchTemporaryFilterData(dealFilterDataParms?.applyFilterData)
                }
            },
        })
    }

    // Active tab state for lazy loading
    const [activeTab, setActiveTab] = useState("followups");
    // Dropdown state for three dots menu
    const [showActionsDropdown, setShowActionsDropdown] = useState(false);
    const actionsDropdownRef = useRef(null);
    const [editDealId, setEditDealId] = useState(null);

    // delete modal loading state
    const [isDeleting, setIsDeleting] = useState(false);
    // for deleting the current deal
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    // // update deal offcanvas state
    const [showUpdateDeal, setShowUpdateDeal] = useState(false);

    // deal feature permission
    const dealfollowupGrant = dealGrant.feature.followup;
    const dealMeetingGrant = dealGrant.feature.meeting;
    const dealDocGrant = dealGrant.feature.document
    const dealNoteGrant = dealGrant.feature.notes

    // ideally i should follow a conditional format here since sales doesn't come under free plan.And this is valid for the quotation as well. For now i am directly doing this but i should update it
    const salesPermission = PERMISSION?.sales_order.isAuthorized;

    // Close dropdowns for actions on outside click
    useOutsideClickHandler({
        objRef: actionsDropdownRef,
        isDropdown: showActionsDropdown,
        setDropdown: setShowActionsDropdown
    })

    //  Toggles actions dropdown menu
    const toggleActionsDropdown = () => setShowActionsDropdown((prev) => !prev);

    // Confirm and execute lead deletion
    const handleDeleteConfirm = async () => {
        try {
            setIsDeleting(true);
            const response = await DeleteRequest(
                `deals/deleteDeal/${dealId}/${loginUserId}`,
                { headers },
                extras,
            );

            if (response?.status === "success") {
                toast.success(response.message);
                setIsDeleting(false);
                // onClose();
                // await refetchDeals();
                navigate('/deals')
            } else {
                toast.error(response?.message || "Failed to delete Deal");
                setIsDeleting(false);
                return;
            }
        } catch (error) {
            setIsDeleting(false);
            toast.error("An error occurred while deleting deal");
        } finally {
            setIsDeleting(false);
            setShowDeleteModal(false);
            // onClose();
        }
    };

    return (
        <>
            <Col
                md={5}
                className="ps-2 h-100"
                style={{ paddingRight: 1, minHeight: 0 }}
            >
                <div
                    style={{ overflow: "hidden", height: "100%" }}
                    className=""
                >
                    <Tab.Container
                        activeKey={activeTab || "followups"}
                        onSelect={(tabKey) => setActiveTab(tabKey)}
                    >
                        <div className="card h-100 cardBorders">
                            <div className="card-header d-flex justify-content-between align-items-center px-3 py-0 cardHeaderBorders">
                                <div style={styles.ulStyles}>
                                    <div className="d-flex align-items-center gap-1 h-100">
                                        <Nav
                                            variant="pills"
                                            className="nav-style-1 mb-0 d-flex flex-nowrap navItemsBeforeStyle gap-2"
                                        >
                                            <Nav.Item
                                                className="me-3"
                                                style={{ width: "65px" }}
                                            >
                                                <Nav.Link eventKey="followups" className="p-0">
                                                    FollowUps
                                                </Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item className="me-3">
                                                <Nav.Link eventKey="notes" className="p-0">
                                                    Notes
                                                </Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item className="me-3">
                                                <Nav.Link eventKey="meetings" className="p-0">
                                                    Meetings
                                                </Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item className="me-3">
                                                <Nav.Link eventKey="documents" className="p-0">
                                                    Documents
                                                </Nav.Link>
                                            </Nav.Item>
                                        </Nav>
                                    </div>
                                    <div className="d-flex align-items-center gap-1">
                                        {/* Three dots menu */}
                                        {
                                            isActionDropReqd &&
                                            <>
                                                <div ref={actionsDropdownRef} className="position-relative">
                                                    <Dropdown
                                                        show={showActionsDropdown}
                                                    >
                                                        <button
                                                            type="button"
                                                            className="btn btn-default"
                                                            style={styles.listWhatsButtonsStyles}
                                                            onClick={(e) => {
                                                                e.stopPropagation()
                                                                setShowActionsDropdown(prev => !prev)
                                                            }}
                                                        >
                                                            <FontAwesomeIcon
                                                                icon={faEllipsisV}
                                                                style={styles.iconStyles}
                                                            />
                                                        </button>
                                                        {showActionsDropdown && (
                                                            <Dropdown.Menu
                                                                className="defaultDropdown"
                                                                style={{
                                                                    width: "10rem",
                                                                    padding: "7px 0px",
                                                                    display: "block",
                                                                    position: "fixed",
                                                                    top: actionsDropdownRef.current
                                                                        ? actionsDropdownRef.current.getBoundingClientRect().bottom + window.scrollY
                                                                        : 0,
                                                                    left: actionsDropdownRef.current
                                                                        ? actionsDropdownRef.current.getBoundingClientRect().right - 160 + window.scrollX
                                                                        : 0,
                                                                    zIndex: 9999,
                                                                    backgroundColor: "#fff",
                                                                    border: "1px solid #dee2e6",
                                                                    borderRadius: "0.375rem",
                                                                    boxShadow:
                                                                        "0 0.5rem 1rem rgba(0, 0, 0, 0.15)",
                                                                }}
                                                            >
                                                                <Dropdown.Item
                                                                    onClick={() => {
                                                                        if (
                                                                            !dealGrant.isEdit
                                                                        ) {
                                                                            toast.warning("You are not authorized for this action!",);
                                                                            return;
                                                                        }
                                                                        if (!canEdit) {
                                                                            toast.warning("You are not a shared pipeline user. You are not authorized for this action!")
                                                                            return;
                                                                        }
                                                                        setShowUpdateDeal(true);
                                                                        setEditDealId(individualDealData.id);
                                                                        setShowActionsDropdown(false)
                                                                    }}
                                                                    className="fs-13 d-flex gap-2 align-items-center"
                                                                >
                                                                    <FontAwesomeIcon icon={faPencil} /> Edit Deal
                                                                </Dropdown.Item>
                                                                <Dropdown.Item
                                                                    onClick={() => {
                                                                        if (
                                                                            !dealGrant.isDelete
                                                                        ) {
                                                                            toast.warning("You are not authorized for this action!",);
                                                                            return;
                                                                        }
                                                                        if (!canEdit) {
                                                                            toast.warning("You are not a shared pipeline user. You are not authorized for this action!")
                                                                            return;
                                                                        }
                                                                        setShowDeleteModal(true);
                                                                        setShowActionsDropdown(false)
                                                                    }}
                                                                    className="fs-13 d-flex gap-2 align-items-center"
                                                                >
                                                                    <FontAwesomeIcon icon={faTrash} /> Delete
                                                                    Deal
                                                                </Dropdown.Item>
                                                                <Dropdown.Item
                                                                    onClick={() => {
                                                                        if (!salesPermission) {
                                                                            toast.warning("Upgrade your user plan to access sales order!",);
                                                                            return;
                                                                        }
                                                                        if (!canEdit) {
                                                                            toast.warning("You are not a shared pipeline user. You are not authorized for this action!")
                                                                            return;
                                                                        }
                                                                        navigate("/createSalesOrder", {
                                                                            state: {
                                                                                contact_id: individualDealData?.contact_id,
                                                                                deal_id: dealId,
                                                                                quotation_id: "",
                                                                            },
                                                                        });
                                                                    }}
                                                                    className="fs-13 d-flex gap-2 align-items-center"
                                                                >
                                                                    <FontAwesomeIcon icon={faCalendar} /> Sales Order
                                                                </Dropdown.Item>
                                                                <Dropdown.Item
                                                                    onClick={() => {
                                                                        setCallLogOpen(true);
                                                                    }}
                                                                    className="fs-13 d-flex gap-2 align-items-center"
                                                                >
                                                                    <FontAwesomeIcon icon={faCalendar} />
                                                                    Call Log
                                                                </Dropdown.Item>
                                                            </Dropdown.Menu>
                                                        )}
                                                    </Dropdown>
                                                </div>
                                                <div style={styles.emptyDivs}></div>
                                                <button
                                                    type="button"
                                                    className="btn btn-default"
                                                    style={styles.listWhatsButtonsStyles}
                                                    onClick={handleCloseDealDetails}
                                                >
                                                    <FontAwesomeIcon
                                                        icon={faXmark}
                                                        style={styles.iconStyles}
                                                    />
                                                </button>
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div
                                className="px-0 pt-0 flex-grow-1"
                                style={{ minHeight: 0, overflow: "hidden" }}
                            >
                                <Tab.Content
                                    className="h-100 d-flex flex-column"
                                    style={{ minHeight: 0 }}
                                >
                                    <Tab.Pane
                                        eventKey="followups"
                                        className="p-0 pt-2"
                                        style={{
                                            border: "none",
                                            animation: "cardEntry 1s ease-out forwards",
                                            // overflow: "auto",
                                            borderRadius: 0,
                                        }}
                                    >
                                        <Followups
                                            followupGrant={dealfollowupGrant}
                                            leadId={dealId}
                                            isActive={activeTab === "followups"}
                                            module_name={"deal"}
                                        />
                                    </Tab.Pane>
                                    <Tab.Pane
                                        eventKey="notes"
                                        className="p-0 pt-2"
                                        style={{
                                            border: "none",
                                            animation: "cardEntry 1s ease-out forwards",
                                            // overflow: "auto",
                                            borderRadius: 0,
                                        }}
                                    >
                                        <Notes
                                            leadId={dealId}
                                            noteGrant={dealNoteGrant}
                                            isActive={activeTab === "notes"}
                                            module_name={"deals"}
                                        />
                                    </Tab.Pane>
                                    <Tab.Pane
                                        eventKey="meetings"
                                        className="p-0 pt-2"
                                        style={{
                                            border: "none",
                                            animation: "cardEntry 1s ease-out forwards",
                                            // overflow: "auto",
                                            borderRadius: 0,
                                        }}
                                    >
                                        {individualDealData?.email && (dealId !== null || dealId !== undefined) && (
                                            <Meetings
                                                leadId={dealId}
                                                meetingGrant={dealMeetingGrant}
                                                isActive={activeTab === "meetings"}
                                                email={individualDealData?.email}
                                                fullName={individualDealData?.contact_name}
                                                module_name={"deals"}
                                            />
                                        )}
                                    </Tab.Pane>
                                    <Tab.Pane
                                        eventKey="documents"
                                        className="p-0 pt-2"
                                        style={{
                                            border: "none",
                                            animation: "cardEntry 1s ease-out forwards",
                                            // overflow: "auto",
                                            borderRadius: 0,
                                        }}
                                    >
                                        <Documents
                                            leadId={dealId}
                                            documentGrant={dealDocGrant}
                                            isActive={activeTab === "documents"}
                                            module_name={"deals"}
                                        />
                                    </Tab.Pane>
                                </Tab.Content>
                            </div>
                        </div>
                    </Tab.Container>
                </div>
            </Col>
            {
                <div>
                    <UpdateDeal
                        show={showUpdateDeal}
                        setShow={setShowUpdateDeal}
                        onHide={() => {
                            setShowUpdateDeal(false);
                            // setSelectedStageId(null);
                            refetchDealDetails();
                        }}
                        moduleName="deals"
                        editId={dealId}
                    />
                </div>
            }

            {
                showDeleteModal && (
                    <DeleteModal
                        show={showDeleteModal}
                        onClose={() => setShowDeleteModal(false)}
                        onConfirm={handleDeleteConfirm}
                        isLoading={isDeleting}
                        message="Are you sure you want to delete this deal?"
                    />
                )
            }
        </>
    )
}

const styles = {

    ulStyles: {
        display: "flex",
        alignItems: "center",
        gap: "3px",
        justifyContent: "space-between",
        width: "100%",
    },
    listWhatsButtonsStyles: {
        fontSize: "13px",
        height: "29px",
        gap: 5,
        width: "auto",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "2px",
    },
    iconStyles: {
        fontSize: 12,
        color: "#fff",
    },
    emptyDivs: {
        borderRight: "1px solid #E0E4F8",
        height: "35px",
        margin: "0px 2px",
    },
}